import * as actionTypes from "./UserMasterTypes";

const INITIAL_STATE = {
    userRoleList: [],
    getUserManagerList: [],
    getUserPolicyList: [],
    departmentlist: [],
    userListItems: [],
    userData: [],
    userDataSave: [],
    vendorCodeList: [],
    designationList: []
};

const UserMasterReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case actionTypes.SETUSERROLE:
            return {
                ...state, userRoleList: action.payload.list
            };
        case actionTypes.SETMANAGER:
            return {
                ...state, getUserManagerList: action.payload.list
            };
        case actionTypes.SETUSERPOLICY:
            return {
                ...state, getUserPolicyList: action.payload.list
            };
        case actionTypes.SETDEPARTLIST:
            return {
                ...state, departmentlist: action.payload.list
            };
        case actionTypes.SETUSERLIST:
            return {
                ...state, userListItems: action.payload.list
            };
        case actionTypes.SETUSERDATA:
            return {
                ...state, userData: action.payload.list
            };
        case actionTypes.SAVEUSERSITEM:
            return {
                ...state, userDataSave: action.payload.list
            };
        case actionTypes.SETVENDORCODE:
            return {
                ...state, vendorCodeList: action.payload.list
            };
        case actionTypes.SETDESIGNATIONLIST:
            return {
                ...state, designationList: action.payload.list
            };
        case actionTypes.CLEARDOC:
            return {
                userRoleList: [],
                getManagerList: [],
                getUserPolicyList: [],
                departmentlist: [],
            };
        default:
            return state;
    }
}

export default UserMasterReducer;

